import { render, staticRenderFns } from "./inputFormToCreateActivo.vue?vue&type=template&id=8c864d76&"
import script from "./inputFormToCreateActivo.vue?vue&type=script&lang=js&"
export * from "./inputFormToCreateActivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports